<template>
  <table class="table table-fixed table-striped table-bordered">
    <tbody>
    <tr>
      <th>Adres</th>
      <td>{{ address }}</td>
      <th>Website</th>
      <td>{{ office.website ? office.website : '-' }}</td>
    </tr>
    <tr>
      <th>Postcode</th>
      <td>{{ office.postcode ? office.postcode : '-' }}</td>
      <th>Kantoorcode</th>
      <td>{{ office.code ? office.code : '-' }}</td>
    </tr>
    <tr>
      <th>Woonplaats</th>
      <td>{{ office.city ? office.city : '-' }}</td>
      <th>AFM-nummer</th>
      <td>{{ office.afm_number ? office.afm_number : '-' }}</td>
    </tr>
    <tr>
      <th>Telefoonnummer</th>
      <td>{{ office.phone ? office.phone : '-' }}</td>
      <th>Kifid-nummer</th>
      <td>{{ office.kifid_number ? office.kifid_number : '-' }}</td>
    </tr>
    <tr>
      <th>E-mailadres</th>
      <td>{{ office.email ? office.email : '-' }}</td>
      <th>Klantportaal link</th>
      <td>{{ office.customer_portal_link ? office.customer_portal_link : '-' }}</td>
    </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  name: 'DropdownComponent',
  props: {
    office: {
      type: Object,
      required: true,
    },
  },
  computed: {
    address() {
      if (!this.office.streetName || !this.office.number) return '-';
      return (this.office.streetName + ' ' + this.office.number)
          .concat(this.office.number_letter ? this.office.number_letter : '')
          .concat(this.office.number_addition ? '-' + this.office.number_addition : '');
    },
  }
}
</script>
